import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteEmailPromoModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteEmailPromoModalContainer" */
      './DeleteEmailPromoModalContainer'
    ),
  loading: LoadingModal,
});
